var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlobSceneHaikei2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#1b4992",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "33.3%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#1b4992",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#a86fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#1b4992",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#a86fff",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "66.7%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#1b4992",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-513.8 0C-511.3 -30 -508.8 -60.1 -501.3 -88.4C-493.7 -116.7 -481.2 -143.2 -470.8 -171.4C-460.4 -199.5 -452.3 -229.2 -432.1 -249.5C-412 -269.8 -380 -280.8 -360.8 -302.8C-341.6 -324.7 -335.3 -357.6 -313 -373.1C-290.7 -388.5 -252.4 -386.6 -220.5 -381.9C-188.6 -377.2 -163.1 -369.7 -144 -395.6C-124.9 -421.5 -112.2 -480.7 -89.2 -506C-66.3 -531.2 -33.1 -522.5 0 -513.8L0 0Z",
    fill: "#002e57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-342.5 0C-340.9 -20 -339.2 -40.1 -334.2 -58.9C-329.2 -77.8 -320.8 -95.5 -313.9 -114.2C-306.9 -133 -301.5 -152.8 -288.1 -166.3C-274.7 -179.9 -253.3 -187.2 -240.5 -201.8C-227.8 -216.5 -223.6 -238.4 -208.7 -248.7C-193.8 -259 -168.3 -257.7 -147 -254.6C-125.7 -251.5 -108.7 -246.5 -96 -263.7C-83.3 -281 -74.8 -320.5 -59.5 -337.3C-44.2 -354.2 -22.1 -348.3 0 -342.5L0 0Z",
    fill: "#5c5fcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-171.3 0C-170.4 -10 -169.6 -20 -167.1 -29.5C-164.6 -38.9 -160.4 -47.7 -156.9 -57.1C-153.5 -66.5 -150.8 -76.4 -144 -83.2C-137.3 -89.9 -126.7 -93.6 -120.3 -100.9C-113.9 -108.2 -111.8 -119.2 -104.3 -124.4C-96.9 -129.5 -84.1 -128.9 -73.5 -127.3C-62.9 -125.7 -54.4 -123.2 -48 -131.9C-41.6 -140.5 -37.4 -160.2 -29.7 -168.7C-22.1 -177.1 -11 -174.2 0 -171.3L0 0Z",
    fill: "#a86fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.8 0C473.9 23.2 434 46.5 426.4 75.2C418.8 103.9 443.5 138.1 431.3 157C419.1 175.9 370.1 179.6 364.6 210.5C359.1 241.4 397.3 299.4 393.6 330.3C389.9 361.1 344.4 364.8 309.2 368.5C273.9 372.1 248.9 375.8 228 394.9C207.1 414 190.5 448.6 165.5 454.8C140.6 461.1 107.3 439 78.3 444.1C49.3 449.3 24.7 481.5 0 513.8L0 0Z",
    fill: "#002e57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5 0C315.9 15.5 289.3 31 284.3 50.1C279.2 69.3 295.7 92 287.5 104.7C279.4 117.3 246.7 119.8 243.1 140.3C239.4 160.9 264.8 199.6 262.4 220.2C259.9 240.7 229.6 243.2 206.1 245.6C182.6 248.1 165.9 250.5 152 263.3C138.1 276 127 299 110.4 303.2C93.7 307.4 71.5 292.7 52.2 296.1C32.9 299.5 16.4 321 0 342.5L0 0Z",
    fill: "#5c5fcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.3 0C158 7.7 144.7 15.5 142.1 25.1C139.6 34.6 147.8 46 143.8 52.3C139.7 58.6 123.4 59.9 121.5 70.2C119.7 80.5 132.4 99.8 131.2 110.1C130 120.4 114.8 121.6 103.1 122.8C91.3 124 83 125.3 76 131.6C69 138 63.5 149.5 55.2 151.6C46.9 153.7 35.8 146.3 26.1 148C16.4 149.8 8.2 160.5 0 171.3L0 0Z",
    fill: "#a86fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei2);
export default __webpack_public_path__ + "static/media/blob-scene-haikei-2.6ed43213becfb8bfe21b505ef9d1cd80.svg";
export { ForwardRef as ReactComponent };